import { InvestFunnelChoiceEvents, InvestFunnelEvents, SaveFunnelEvents, } from './types';
// Screen that starts each step. ONB_SAVE_NEXT_FREQUENCY is sent by
// AutosaveOnboardingIntroScreen, which opens AutosaveChoosePeriod directly.
// ONB_SAVE_NEXT_ISA_DECLARATION is sent by ReviewAndConfirmScreen, which opens
// InvestSecclISADeclarationScreen directly.
export const saveNextStepEvents = {
    SelectPotType: SaveFunnelEvents.ONB_SAVE_NEXT_POT_TYPE,
    InvestPersonalDetails: SaveFunnelEvents.ONB_SAVE_NEXT_PERSONAL_DETAILS,
    InvestAddress: SaveFunnelEvents.ONB_SAVE_NEXT_ADDRESS,
    AddressPostCodeScreen: SaveFunnelEvents.ONB_SAVE_NEXT_ADDRESS,
    InvestInsurance: SaveFunnelEvents.ONB_SAVE_NEXT_TAX,
    InvestAnnualIncome: SaveFunnelEvents.ONB_SAVE_NEXT_ANNUAL_INCOME,
    CreatePot: SaveFunnelEvents.ONB_SAVE_NEXT_POT_DETAILS,
    ReviewAndConfirm: SaveFunnelEvents.ONB_SAVE_NEXT_POT_DETAILS,
    PotInitialDepositAmountScreen: SaveFunnelEvents.ONB_SAVE_NEXT_INITIAL_AMOUNT,
    AutosaveKnowContributionAmount: SaveFunnelEvents.ONB_SAVE_NEXT_AUTO_AMOUNT,
    AutosaveOverdraftSettings: SaveFunnelEvents.ONB_SAVE_NEXT_OVERDRAFT,
    SelectFundingAccount: SaveFunnelEvents.ONB_SAVE_NEXT_FUNDING_ACCOUNT,
    AutosaveSelectFundingAccount: SaveFunnelEvents.ONB_SAVE_NEXT_FUNDING_ACCOUNT,
    PotsOnboardingReviewDepositAndAutosaveInfoScreen: SaveFunnelEvents.ONB_SAVE_NEXT_REVIEW_CONFIRM,
};
// Screen that starts each step. ONB_INVEST_NEXT_COLLECTION_DATE is sent by
// AutoinvestIntroScreen, which opens AutoinvestPickCollectionDate directly.
// ONB_INVEST_NEXT_ISA_DECLARATION (ISA and JISA) is sent by
// BrokerRequirementsScreen, which opens InvestSecclISADeclarationScreen
// directly.
export const investNextStepEvents = {
    InvestSelectSecclAccountType: InvestFunnelEvents.ONB_INVEST_NEXT_ACCOUNT_TYPE,
    InvestPersonalDetails: InvestFunnelEvents.ONB_INVEST_NEXT_PERSONAL_DETAILS,
    InvestAddress: InvestFunnelEvents.ONB_INVEST_NEXT_ADDRESS,
    AddressPostCodeScreen: InvestFunnelEvents.ONB_INVEST_NEXT_ADDRESS,
    InvestInsurance: InvestFunnelEvents.ONB_INVEST_NEXT_TAX,
    InvestAnnualIncome: InvestFunnelEvents.ONB_INVEST_NEXT_ANNUAL_INCOME,
    InvestBrokerRequirements: InvestFunnelEvents.ONB_INVEST_NEXT_TERMS,
    StartInvestReadyMadeFunds: InvestFunnelEvents.ONB_INVEST_NEXT_ASSET_PICK,
    SetupContributionsChooseInitialAmount: InvestFunnelEvents.ONB_INVEST_NEXT_INITIAL_AMOUNT,
    SetupContributionsChooseMonthlyAmount: InvestFunnelEvents.ONB_INVEST_NEXT_AUTO_AMOUNT,
    SelectFundingAccount: InvestFunnelEvents.ONB_INVEST_NEXT_FUNDING_ACCOUNT,
    AutoinvestSelectFundingAccount: InvestFunnelEvents.ONB_INVEST_NEXT_FUNDING_ACCOUNT,
    InvestReviewAndConfirm: InvestFunnelEvents.ONB_INVEST_NEXT_REVIEW_CONFIRM,
};
export const accountTypeChoiceEvents = {
    ISA: InvestFunnelChoiceEvents.ONB_INVEST_TYPE_ISA,
    GIA: InvestFunnelChoiceEvents.ONB_INVEST_TYPE_GIA,
    JISA: InvestFunnelChoiceEvents.ONB_INVEST_TYPE_JISA,
};
